<!--TODO: figure out why validation is fucked up-->
<template>
  <div>


    <v-card
        class="elevation-12"
        color="#488ba6"
        dark
        style="margin-bottom: 2em"
    >
      <v-card-title class="headline">{{ state.member.app.membershipType.text }} Member
        Application:
        {{
          new Intl.NumberFormat('en-US', {
            style: 'currency', currency: 'USD'
          }).format(state.member.app.membershipType.fee)
        }}
      </v-card-title>


    </v-card>

    <v-form @submit.prevent="submitApplication" ref="appForm" v-model="valid">
      <v-card class="elevation-12 mb-5" v-for="fieldSet in state.member.fieldSets" :key="fieldSet.name">

        <div v-if="fieldSet.name">
          <v-toolbar
              color="#488ba6"
              dark
              flat

          >
            <v-toolbar-title>{{ fieldSet.displayName }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>

            <v-row v-for="(field, index) in fieldSet.fields"
                   :key="index">
              <v-col class="d-flex" lg="6" sm="12" v-if="field.type === 'select'">
                <h4>{{ fieldSet.label }}</h4>
                <v-select
                    :items="field.options"
                    :label="field.label+' '+(field.required ? '*' : '')"
                    item-text="text"
                    v-model="field.value"
                    :required="field.required"
                    item-value="value"
                    :rules="[(v) => {
                                            if(!!!v && field.required){
                                                return field.label+' is required';
                                            }
                                        }]"
                    attach
                ></v-select>
              </v-col>
              <v-col class="d-flex" lg="12" sm="12" v-else-if="field.type === 'group'">


                <v-row v-for="(detailGroup, index) in field.fields" :key="index">


                  <v-col cols="10" md='10' sm="6"><h5 class="d-inline-flex">
                    {{ detailGroup.label }}
                    <span style="margin-left:3px" v-if="field.label != 'Address'">{{ field.label }}</span></h5></v-col>

                  <v-col cols="10" md='10' sm="5" v-for="(detailField, index) in detailGroup.fields"
                         :key="index">
                    <div v-if="detailField.type ==='textarea'">
                      <v-textarea
                          :label="detailField.label+' '+(detailField.required ? '*' : '')"
                          v-model="detailField.value"
                          :type="detailField.type"
                          :required="detailField.required"
                          :name="detailField.name"
                          auto-grow
                          :counter="300"
                          filled
                          :rules="[(v) => {
                                            if(!!!v && detailField.required){
                                                return detailField.label+' is required';
                                            }
                                        }]"
                      ></v-textarea>
                    </div>
                    <div v-else-if="detailField.type !== 'select'">
                      <v-text-field
                          v-if="detailGroup.name === 'residency' && field.name === 'degrees' && state.member.app.membershipType.text === 'Resident/Fellow'"
                          :label="detailField.label+' '+detailGroup.label+' '+(detailField.required ? '*' : '')"
                          v-model="detailField.value"
                          :type="detailField.type"
                          :required="!detailField.required"
                          :name="detailField.name"
                          attach
                          :rules="[(v) => {
                                            if(!!!v && !detailField.required){
                                                return detailField.label+' is required for residents';
                                            }
                                        }]"
                      ></v-text-field>
                      <v-text-field
                          v-else
                          :label="detailField.label+' '+detailGroup.label+' '+(detailField.required ? '*' : '')"
                          v-model="detailField.value"
                          :type="detailField.type"
                          :required="detailField.required"
                          :name="detailField.name"
                          attach
                          :rules="[(v) => {
                                            if(!!!v && detailField.required){
                                                return detailField.label+' is required';
                                            }
                                        }]"
                      ></v-text-field>
                    </div>

                    <div v-else>
                      <v-select
                          :items="detailField.options"
                          item-text="text"
                          item-value="value"
                          :label="detailField.label+' '+(detailField.required ? '*' : '')"
                          v-model="detailField.value"
                          :required="detailField.required"
                          return-object
                          single-line
                          attach
                          :rules="[(v) => {
                                            if(!!!v && detailField.required){
                                                return detailField.label+' is required';
                                            }
                                        }]"
                      >
                      </v-select>
                    </div>
                  </v-col>
                </v-row>

              </v-col>
              <v-col class="d-flex" cols="12" v-else-if="field.type === 'combo'">
                <v-combobox
                    v-model="field.value"
                    :items="field.options"
                    :label="field.label+' '+(field.required ? '*' : '')"
                    :required="field.required"
                    multiple
                    chips
                    :rules="[(v) => {
                                            if(!!!v && field.required){
                                                return field.label+' is required';
                                            }
                                        }]"
                ></v-combobox>
              </v-col>

              <v-col class="d-flex" cols="12" v-else>

                <h4>{{ fieldSet.label }} </h4>
                <v-text-field
                    :label="field.label+' '+(field.required ? '*' : '')"
                    v-model="field.value"
                    :type="field.type"
                    :required="field.required"
                    :rules="[(v) => {
                                            if(!!!v && field.required){
                                                return field.label+' is required';
                                            }
                                        }]"
                ></v-text-field>

              </v-col>
              <!--<v-col align="center" v-if="field.multiple">-->
              <!--<v-btn @click="addNew(fieldSet.name)">Add New</v-btn>-->
              <!--</v-col>-->
            </v-row>

          </v-card-text>
        </div>
      </v-card>

      <v-card class="elevation-12 mb-5" v-for="(attachment, index) in state.member.attachments" :key="index">
        <v-toolbar
            color="#488ba6"
            dark
            flat

        >
          <v-toolbar-title>Attachment #{{ index + 1 }}</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-file-input :label="attachment.label+' (max file size 8MB)'" v-model="attachment.file"
                        :ref="attachment.name"></v-file-input>
          <v-btn v-if="attachment.link" :href="attachment.link" target="_blank">Worksheet (fill out and attach above)
          </v-btn>
        </v-card-text>
      </v-card>

      <PromoCode></PromoCode>
      <v-card class="elevation-12">

        <v-toolbar
            color="#488ba6"
            dark
            flat

        >
          <v-toolbar-title v-if="state.member.app.amount > 0">Payment</v-toolbar-title>
          <v-toolbar-title v-else>Submit Application</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text v-if="state.member.app.membershipType.fee > 0">

          <v-select
              prepend-icon="mdi-credit-card"
              :items="ccTypes"
              label="Credit Card Type"
              item-text="text"
              item-value="val"
              v-model="state.payment.cc.type"
              attach
              required
          ></v-select>
          <v-text-field
              label="Credit Card Number"
              name="cc-number"
              prepend-icon="mdi-credit-card"
              type="text"
              v-model="state.payment.cc.number"
              :rules="[v => !!v || 'Card Number is required']"
              required
          ></v-text-field>

          <v-text-field
              label="Credit Card First Name"
              name="cc-first-name"
              prepend-icon="mdi-form-textbox"
              type="text"
              v-model="state.payment.cc.firstName"
              :rules="[v => !!v || 'Card first name is required']"
              required
          ></v-text-field>
          <v-text-field
              label="Credit Card Last Name"
              name="cc-last-name"
              prepend-icon="mdi-form-textbox"
              type="text"
              v-model="state.payment.cc.lastName"
              :rules="[v => !!v || 'Card last name is required']"
              required
          ></v-text-field>
          <v-text-field
              label="Expiry (Month/Year, 01/24)"
              placeholder='••/••'
              name="cc-exp"
              prepend-icon="mdi-calendar-range"
              type="text"
              v-model="state.payment.cc.expiry"
              :rules="[rules.required, expiry_validate]"
              required
          ></v-text-field>
          <v-text-field
              label="CVV"
              name="cc-cvv"
              prepend-icon="mdi-credit-card-refund"
              type="text"
              v-model="state.payment.cc.cvv"
              :rules="[v => !!v || 'Card cvv is required']"
              required
          ></v-text-field>
          <v-switch
              v-model="state.payment.autopay.addAutopay"
              label="AutoPay Dues Renewal:"
          ></v-switch>
          <v-card-text>
              I agree to enroll in AutoPay. FVS will charge the provided credit card the published membership fee<br>
              on January 2 of each year for dues. The FVS will notify me by email 60 days prior that the payment<br>
               is occurring. I may cancel the automatic payment by contacting FVS in writing at least 30 days prior<br>
              to the payment occurring.
          </v-card-text>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#488ba6" type="submit" style="color:white" :disabled="!valid">Submit Application</v-btn>
        </v-card-actions>
        <v-alert class="mt-2" type="warning" v-if="!valid">
          <small>You have not filled out all of the required fields, please fill out all the fields labeled with a *</small>
        </v-alert>
        <v-alert class="mt-2" type="error" v-if="this.state.payment.response.errorMsg">
          <small>{{ this.state.payment.response.errorMsg }} | Please refresh the page to try again.</small>
        </v-alert>
      </v-card>
    </v-form>
  </div>
</template>

<script>

import {mapGetters, mapState} from 'vuex'
import PromoCode from './PromoCode';

export default {
  name: "Application",
  data: function () {
    return {
      ccTypes: [
        {
          text: 'Visa',
          val: 'Visa'
        },
        {
          text: 'MasterCard',
          val: 'MC'
        },
        {
          text: 'American Express',
          val: 'AMEX'
        },
      ],
      valid: true,
      rules: {
        required: v => !!v || 'Required.',

      },
    }
  },
  computed: {
    ...mapGetters({
      state: 'getState',
    }),
    ...mapState({
      autopay: state => state.payment.autopay.addAutopay
    }),

  },
  methods: {
    submitApplication: function () {

      if (this.$refs.appForm.validate()) {
        this.$store.dispatch('saveApplication');
      }

    },
    expiry_validate: function (v) {
      let out = true;
      let message;
      //let autopay = this.state.payment.autopay.addAutopay;
      let expiry_part;
      let today = new Date();
      let current_month = today.getMonth();
      let current_year = today.getFullYear();
      let current_y_two;

      if (this.autopay) {
        if (v.indexOf("/") == 2 ){

          expiry_part = v.split("/"); //expiry_part[0] is the month, expiry_part[1] is the year

          current_y_two = current_year.toString().substr(2,2);

          if ((expiry_part[1] == current_y_two && expiry_part[0] <= current_month) || ( expiry_part[1] !='' && expiry_part[1] < current_y_two) ){
            message = 'Invalid expiry date: expired card '
            out = false;
          }

          if (v.length < 5 ){
            message = 'Invalid expiry date format mm/yy '
            out = false;
          }

        }
        else  {
          out = false;
          message = 'Invalid expiry date format mm/yy '
        }
      }

      // console.log('out is ' + out + ' message is: ' + message);
      // console.log('autopay is ' + this.autopay);

      return out || message ;
    }
  },
  components:{
    PromoCode
  }
}
</script>

<style scoped>

</style>